import { stepsReducer } from './slice'

export const steps = stepsReducer

export default stepsReducer
